import React, { Component } from 'react';

import { Robots } from '../Components/Robots';
import SearchBox from '../Components/SearchBox';
import CardList from '../Components/CardList';
import Scroll from '../Components/scroll'


class App extends Component{
	constructor(){
		super()
		this.state = {
			Robots : Robots,
			searchField : '',
		}
	}

	componentDidMount(){
		fetch('https://jsonplaceholder.typicode.com/users').then(response => {
			return response.json()
		}).then(users => {
			this.setState({Robots : users})
		})
	}

	onSearchChange = (event) => {
		this.setState({searchField : event.target.value})
	}

	render(){

		const filterRobots = this.state.Robots.filter( robots => {
			return(
				robots.name.toLowerCase().includes(this.state.searchField.toLowerCase())
			)
		} );

		return(
			<div className = 'tc'>
				<SearchBox onSearchChange = {this.onSearchChange} />
				<Scroll>
					<CardList Robots = {filterRobots}/>
				</Scroll>
			</div>
		);
	}
}

export default App;